import { render } from "./BaseDoughnutChart.vue?vue&type=template&id=9971b43e&scoped=true"
import script from "./BaseDoughnutChart.vue?vue&type=script&lang=js"
export * from "./BaseDoughnutChart.vue?vue&type=script&lang=js"

import "./BaseDoughnutChart.vue?vue&type=style&index=0&id=9971b43e&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9971b43e"],['__file',"src/components/charts/BaseDoughnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9971b43e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9971b43e', __exports__)) {
    console.log('reload')
    api.reload('9971b43e', __exports__)
  }
  
  module.hot.accept("./BaseDoughnutChart.vue?vue&type=template&id=9971b43e&scoped=true", () => {
    console.log('re-render')
    api.rerender('9971b43e', render)
  })

}


export default __exports__